import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Rate from '../../../../../shared/uielements/Engage/EngageButtons/RateButton';
import { hostNameAndPort } from '../../../../../shared/util/vars';
import { formatPriceAndCurrency } from '../../../../../shared/util/number';
import Axios from 'axios';
import {connect} from 'react-redux';
import { getTranslatedPhrase } from '../../../../../shared/util/lang';
import EngageButtons from '../../../../../shared/uielements/Engage/EngageButtons/EngageButtons';



class WallTravel extends Component {
    state = {
        travelNotFound: true,
        featuredImage: '',
        title: '',
        averageRating: 5,
    }

    componentDidMount() {
        let b = this.props.travelId;
        if (!b) {
            this.setState({ travelNotFound: true });
            return;
        }
        let url = `${hostNameAndPort}/api/travel/${b}`;
        Axios(url)
        .then(result => {
            let {data} = result;
            if (!data.error) {                
                data.item.creationDate = (new Date(data.item.creationDate)).toDateString();
                //data.item.travelContent = (data.item.travelContent).split('\n');
                data.item.travelNotFound = false;
                this.setState(data.item);
                let _wallAction;
                switch (this.props.activityType) {
                    case 'review':
                    _wallAction = 'rated a travel listing';
                    break;
                    case 'like':
                    _wallAction = 'liked a travel listing';
                    break;
                    case 'post':
                    _wallAction = 'posted a travel listing';
                    break;
                    case 'share':
                    _wallAction = 'shared a travel listing';
                    break;
                    default:
                    break;
                }
                this.props.onItemLoaded({
                    itemFailedLoading: false,
                    wallAction: _wallAction,
                });
            } 
            else {
                this.props.onItemLoaded({ itemFailedLoading: true });
            }
        })
        .catch(err => {
            //console.log('Network error');
            this.props.onItemLoaded({ itemFailedLoading: true });
        });
    }

    render () {
        if (this.state.travelNotFound) {
            return '';
        }
        let listingSlug = `/travel/${this.state.category}/${this.state.slug}`;
        return (
            <div className="WallProduct">
                <Link to={listingSlug}>
                    <img src={this.state.featuredImage} alt={this.state.title} />
                </Link>

                <div className="WallProductDetails">
                    <div className="left">
                        <h4>{this.state.title}</h4>
                        <p className="WallProductPrice">{formatPriceAndCurrency(this.state.price,this.state.currency,',')}</p>
                        <div className="Walltravel listingRating"> 
                        <EngageButtons>
                            <Rate noStars={this.state.averageRating} />
                        </EngageButtons>
                        </div>
                    </div>

                    <div className="right">
                    <Link to={listingSlug}>{getTranslatedPhrase(this.props.userLanguage,'See Details')}</Link>
                    </div>

                    <div className="clb" />
                </div>
            </div>
        );
    }
}



const mapStateToWallTravelProps = (
    state,
    props
) => {
    return {
        userLanguage: state.userLanguage,
    };
};

export default connect(mapStateToWallTravelProps, null)(WallTravel);
